export const apiUrl = process.env.REACT_APP_API_URL;
export const authTokenKey = process.env.REACT_APP_AUTH_TOKEN_KEY;
export const bucketPrefix = `https://${process.env.REACT_APP_AWS_BUCKET_NAME}.s3.amazonaws.com/`;
export const headerAuthTokenKey = process.env.REACT_APP_HEADER_AUTH_TOKEN;
